<div class="m-file-select">
    <input ref="inputFile"
           :id="id"
           class="m-file-select__hidden"
           type="file"
           :disabled="disabled || isWaiting"
           tabindex="-1"
           :multiple="multiple"
           :accept="extensions"
           @change="processFile"/>
    <label :for="id"
           class="m-file-select__hidden">
        {{ label || $i18n.translate('m-select-file:label') }}
    </label>
    <m-button aria-hidden="true"
              :skin="skin"
              :disabled="disabled"
              :waiting="waiting"
              :full-size="fullSize"
              :icon-name="iconName"
              :icon-position="iconPosition"
              :icon-size="iconSize"
              @click="onClick"
              @focus="onFocus"
              @blur="onBlur">
        {{ label || $i18n.translate('m-select-file:label') }}
    </m-button>
    <m-validation-message ref="validation"
                          :disabled="isDisabled"
                          :error="hasError"
                          :error-message="errorMessage"
                          :valid-message="validMessage"
                          :helper-message="helperMessage"></m-validation-message>
</div>
